module.exports = __webpack_public_path__ + "static/media/step-6-en.85efc37b.jpg";